import styles from './Tip.module.scss';

type Props = {
    icon: React.FunctionComponent<
        React.SVGProps<SVGSVGElement> & {
            title?: string | undefined;
        }
    >;
    children: React.ReactNode;
    mt?: string;
    mb?: string;
    ml?: string;
    mr?: string;
    style?: React.CSSProperties;
};

const Tip = ({ icon, children, mt, mb, ml, mr, style }: Props) => {
    const Icon = icon;

    return (
        <div
            className={styles.tip}
            style={{
                marginTop: mt ? mt : '',
                marginBottom: mb ? mb : '',
                marginLeft: ml ? ml : '',
                marginRight: mr ? mr : '',
                ...style,
            }}
        >
            <div>
                <Icon fill="#4A52BB" />
            </div>
            <span className={styles['tip__desc']}>{children}</span>
        </div>
    );
};

export default Tip;
